import { useState } from 'react';
import { Icon } from '@sakhtar/design-system/react';
import type { SourceBlock } from '../types.js';

export interface SourceCardProps {
  readonly source: SourceBlock;
  readonly defaultOpen?: boolean;
}

/** Component 6 — collapsible «منبع پاسخ» card (what the answer was built from). */
export function SourceCard({ source, defaultOpen = false }: SourceCardProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="ai-block ai-source" data-open={open}>
      <button
        type="button"
        className="ai-source__head"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span className="ai-source__icon">
          <Icon name="layers" size="sm" />
        </span>
        <span className="ai-source__title">منبع پاسخ</span>
        <span className="ai-source__chevron">
          <Icon name="chevronDown" size="sm" />
        </span>
      </button>
      {open ? (
        <div className="ai-source__body">
          {source.lines.map((line) => (
            <span key={line}>{line}</span>
          ))}
          {source.postedOnly ? (
            <span className="ai-source__note">
              پاسخ‌های حسابداری همیشه فقط از اسناد قطعی (Posted) ساخته می‌شوند.
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
